import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';
import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

interface WithdrawalHistoryHeaderType {
    isBlurred: boolean;
}

export const WithdrawalHistoryHeader = styled('div', { label: 'WithdrawalHistoryHeader' }) <WithdrawalHistoryHeaderType>`
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;

    color: ${mainColors.main.secondary};
    cursor: pointer;
    font-weight: bold;
    margin: auto 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: ${({ isBlurred }): number => isBlurred === true ? 0.4 : 1};
`;

interface WithdrawalHistoryType {
    isCollapsed: boolean;
}
export const WithdrawalHistoryWrapper = styled('div', { label: 'WithdrawalHistoryWrapper' }) <WithdrawalHistoryType>`
    grid-column-start: 1;
    grid-column-end: end;
    grid-row-start: 3;
    grid-row-end: 3;

    display: ${({ isCollapsed }): string => isCollapsed === true ? 'none' : 'initial'};
`;

export const ChevronDownWrapper = styled(ChevronDownIcon, { label: 'ChevronDownWrapper' }) <WithdrawalHistoryType>`
    transition: all 0.5s;
    transform: ${({ isCollapsed }): string => isCollapsed === true ? 'rotate(0)' : 'rotate(180deg)'};
    fill: ${mainColors.main.secondary};
    margin: 0 8px 2px 0;
`;
